import axios from "../../config/axiosConfig";
import {
  DASHBOARD_REPORT_REQUEST,
  DASHBOARD_REPORT_SUCCESS,
  DASHBOARD_REPORT_FAILURE,
  DASHBOARD_PURCHASE_DUE_BILLS_REQUEST,
  DASHBOARD_PURCHASE_DUE_BILLS_SUCCESS,
  DASHBOARD_PURCHASE_DUE_BILLS_FAILURE,
  DASHBOARD_SALES_DUE_BILLS_REQUEST,
  DASHBOARD_SALES_DUE_BILLS_SUCCESS,
  DASHBOARD_SALES_DUE_BILLS_FAILURE,
  DASHBOARD_SALES_DATA_CHART_BILLS_REQUEST,
  DASHBOARD_SALES_DATA_CHART_BILLS_SUCCESS,
  DASHBOARD_SALES_DATA_CHART_BILLS_FAILURE,
  DASHBOARD_RECEIVABLE_OUTSTANDING_REQUEST,
  DASHBOARD_RECEIVABLE_OUTSTANDING_SUCCESS,
  DASHBOARD_RECEIVABLE_OUTSTANDING_FAILURE,
  DASHBOARD_PAYABLE_OUTSTANDING_REQUEST,
  DASHBOARD_PAYABLE_OUTSTANDING_SUCCESS,
  DASHBOARD_PAYABLE_OUTSTANDING_FAILURE,
  DASHBOARD_REMINDER_REQUEST,
  DASHBOARD_REMINDER_SUCCESS,
  DASHBOARD_REMINDER_FAILURE,
  DASHBOARD_EWAYBILL_PENDING_CLOSUER_REQUEST,
  DASHBOARD_EWAYBILL_PENDING_CLOSUER_SUCCESS,
  DASHBOARD_EWAYBILL_PENDING_CLOSUER_FAILURE,
  DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_REQUEST,
  DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_SUCCESS,
  DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_FAILURE,

  DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_REQUEST,
  DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_SUCCESS,
  DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_FAILURE,

  DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_REQUEST,
  DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_SUCCESS,
  DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_FAILURE,

  DASHBOARD_PENDING_SCHEDULE_QTY_DATA_REQUEST,
  DASHBOARD_PENDING_SCHEDULE_QTY_DATA_SUCCESS,
  DASHBOARD_PENDING_SCHEDULE_QTY_DATA_FAILURE
} from "../types/dashboard-report-types";

export const getDashboardReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      const defaultParams2 = {
        fromDate: auth?.finyear?.From_Date, 
        toDate: auth?.finyear?.To_Date, 
        ...params
      };
      const requestParams = { ...defaultParams, ...defaultParams2 };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardReport?${queryString}`;

      axios.get(fullUrl).then((response) => {
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: DASHBOARD_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Dashboard Report:", error);
        dispatch({ type: DASHBOARD_REPORT_FAILURE, error: error.message });
      });  // Use the full URL directly
    } catch (error) {
      console.error("Error fetching Dashboard Report:", error);
      dispatch({ type: DASHBOARD_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getDashboardReceivableReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_RECEIVABLE_OUTSTANDING_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        fromDate: auth?.finyear?.From_Date, 
        toDate: auth?.finyear?.To_Date, 
        ...params
      };
      const requestParams = { ...defaultParams, ...defaultParams2 };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardReceivableReport?${queryString}`;

      axios.get(fullUrl).then((response) => {
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: DASHBOARD_RECEIVABLE_OUTSTANDING_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Dashboard Report:", error);
        dispatch({ type: DASHBOARD_RECEIVABLE_OUTSTANDING_FAILURE, error: error.message });
      });  // Use the full URL directly

      
    } catch (error) {
      console.error("Error fetching Dashboard Report:", error);
      dispatch({ type: DASHBOARD_RECEIVABLE_OUTSTANDING_FAILURE, error: error.message });
    }
  };
};

export const getDashboardPayableReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_PAYABLE_OUTSTANDING_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      const defaultParams2 = {
        fromDate: auth?.finyear?.From_Date, 
        toDate: auth?.finyear?.To_Date, 
        ...params
      };
      const requestParams = { ...defaultParams, ...defaultParams2 };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardPayableReport?${queryString}`;

      axios.get(fullUrl).then((response) => {
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: DASHBOARD_PAYABLE_OUTSTANDING_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Dashboard Report:", error);
        dispatch({ type: DASHBOARD_PAYABLE_OUTSTANDING_FAILURE, error: error.message });
      });  // Use the full URL directly

      
    } catch (error) {
      console.error("Error fetching Dashboard Report:", error);
      dispatch({ type: DASHBOARD_PAYABLE_OUTSTANDING_FAILURE, error: error.message });
    }
  };
};

export const getDashboardPurchaseDueBillsReport = (showAll, page, pagesize) => {  
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_PURCHASE_DUE_BILLS_REQUEST });

      const { auth } = getState();
      const requestParams = {
        ...(showAll ? {} : { companyId: auth.company?.id }),
        page: page,
        pagesize: pagesize
      };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardPurchaseDueBillsReport?${queryString}`;

      axios.get(fullUrl).then(
        (response) => {
          // Dispatch success action with data
          if (response.data) {
            dispatch({ type: DASHBOARD_PURCHASE_DUE_BILLS_SUCCESS, payload: response.data });
          }
        }
      ).catch((error) =>{
        console.error("Error fetching Dashboard Report:", error);
        dispatch({ type: DASHBOARD_PURCHASE_DUE_BILLS_FAILURE, error: error.message });  
      });  // Use the full URL directly

      
    } catch (error) {
      console.error("Error fetching Dashboard Report:", error);
      dispatch({ type: DASHBOARD_PURCHASE_DUE_BILLS_FAILURE, error: error.message });
    }
  };
};

export const getDashboardSalesDueBillsReport = (showAll, page, pagesize) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_SALES_DUE_BILLS_REQUEST });

      const { auth } = getState();
      const requestParams = {
        ...(showAll ? {} : { companyId: auth.company?.id }),
        page: page,
        pagesize: pagesize
      };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardSalesDueBillsReport?${queryString}`;

      axios.get(fullUrl).then(
        (response) => {
          // Dispatch success action with data
          if (response.data) {
            dispatch({ type: DASHBOARD_SALES_DUE_BILLS_SUCCESS, payload: response.data });
          }
        }
      ).catch((error) => {
        console.error("Error fetching Dashboard Report:", error);
        dispatch({ type: DASHBOARD_SALES_DUE_BILLS_FAILURE, error: error.message }); 
      });  // Use the full URL directly

    } catch (error) {
      console.error("Error fetching Dashboard Report:", error);
      dispatch({ type: DASHBOARD_SALES_DUE_BILLS_FAILURE, error: error.message });
    }
  };
};

export const getDashboardSalesDataChartReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_SALES_DATA_CHART_BILLS_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      const defaultParams2 = {
        fromDate: auth?.finyear?.From_Date, 
        toDate: auth?.finyear?.To_Date, 
        ...params
      };
      const requestParams = { ...defaultParams, ...defaultParams2 };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardSalesDataChartReport?${queryString}`;

      axios.get(fullUrl).then(
        (response) => {
          // Dispatch success action with data
          if (response.data) {
            dispatch({ type: DASHBOARD_SALES_DATA_CHART_BILLS_SUCCESS, payload: response.data });
          }
        }
      ).catch((error) => {
        console.error("Error fetching Dashboard Report:", error);
        dispatch({ type: DASHBOARD_SALES_DATA_CHART_BILLS_FAILURE, error: error.message });
      });  // Use the full URL directly


      
    } catch (error) {
      console.error("Error fetching Dashboard Report:", error);
      dispatch({ type: DASHBOARD_SALES_DATA_CHART_BILLS_FAILURE, error: error.message });
    }
  };
};

export const getDashboardOrderItemWiseQty = (showAll, page, pagesize) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_REQUEST });

      const { auth } = getState();
      const defaultParams2 = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        // ...(showAll ? {} : { companyId: auth.company?.id }),
        page: page,
        pagesize: pagesize
      };
      const requestParams = {...defaultParams2 };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardOrderItemWiseQty?${queryString}`;

      axios.get(fullUrl).then(
        (response) => {
          // Dispatch success action with data
          if (response.data) {
            dispatch({ type: DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_SUCCESS, payload: response.data });
          }
        }
      ).catch((error) => {
        console.error("Error fetching Dashboard Bal Report:", error);
        dispatch({ type: DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_FAILURE, error: error.message });
      });  // Use the full URL directly


      
    } catch (error) {
      console.error("Error fetching Dashboard Bal Report:", error);
      dispatch({ type: DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_FAILURE, error: error.message });
    }
  };
};

export const getDashboardDeliveryChallanItemWiseQty = (showAll, page, pagesize) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_REQUEST });

      const { auth } = getState();
      const defaultParams2 = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        // ...(showAll ? {} : { companyId: auth.company?.id }),
        page: page,
        pagesize: pagesize
      };
      const requestParams = {...defaultParams2 };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardDeliveryChallanItemWiseQty?${queryString}`;

      axios.get(fullUrl).then(
        (response) => {
          // Dispatch success action with data
          if (response.data) {
            dispatch({ type: DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_SUCCESS, payload: response.data });
          }
        }
      ).catch((error) => {
        console.error("Error fetching Dashboard Bal Report:", error);
        dispatch({ type: DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_FAILURE, error: error.message });
      });  // Use the full URL directly


      
    } catch (error) {
      console.error("Error fetching Dashboard Bal Report:", error);
      dispatch({ type: DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_FAILURE, error: error.message });
    }
  };
};

export const getDashboardOrderDeliveryScheduleBalQty = (showAll, page, pagesize) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_REQUEST });

      const { auth } = getState();
      const defaultParams2 = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        // ...(showAll ? {} : { companyId: auth.company?.id }),
        page: page,
        pagesize: pagesize
      };
      const requestParams = {...defaultParams2 };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardOrderDeliveryScheduleBalQty?${queryString}`;

      axios.get(fullUrl).then(
        (response) => {
          // Dispatch success action with data
          if (response.data) {
            dispatch({ type: DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_SUCCESS, payload: response.data });
          }
        }
      ).catch((error) => {
        console.error("Error fetching Dashboard Bal Report:", error);
        dispatch({ type: DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_FAILURE, error: error.message });
      });  // Use the full URL directly


      
    } catch (error) {
      console.error("Error fetching Dashboard Bal Report:", error);
      dispatch({ type: DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_FAILURE, error: error.message });
    }
  };
};


export const getDashboardTodayPendingOrderDeliverySchedule = (showAll, page, pagesize) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_PENDING_SCHEDULE_QTY_DATA_REQUEST });

      const { auth } = getState();
      const defaultParams2 = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        // ...(showAll ? {} : { companyId: auth.company?.id }),
        page: page,
        pagesize: pagesize
      };
      const requestParams = {...defaultParams2 };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/dashboard/getDashboardTodayPendingOrderDeliverySchedule?${queryString}`;

      axios.get(fullUrl).then(
        (response) => {
          // Dispatch success action with data
          if (response.data) {
            dispatch({ type: DASHBOARD_PENDING_SCHEDULE_QTY_DATA_SUCCESS, payload: response.data });
          }
        }
      ).catch((error) => {
        console.error("Error fetching Dashboard Bal Report:", error);
        dispatch({ type: DASHBOARD_PENDING_SCHEDULE_QTY_DATA_FAILURE, error: error.message });
      });  // Use the full URL directly


      
    } catch (error) {
      console.error("Error fetching Dashboard Bal Report:", error);
      dispatch({ type: DASHBOARD_PENDING_SCHEDULE_QTY_DATA_FAILURE, error: error.message });
    }
  };
};

export const getDashboardReminders = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_REMINDER_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, userId: auth.user?.id, companyId: auth.company?.id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/dashboard/getDashboardAllReminder", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: DASHBOARD_REMINDER_SUCCESS, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DASHBOARD_REMINDER_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DASHBOARD_REMINDER_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getEwayBillPendingClosures = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_EWAYBILL_PENDING_CLOSUER_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, userId: auth.user?.id, companyId: auth.company?.id };

      return axios.get("/eway-bill/closure-pending", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: DASHBOARD_EWAYBILL_PENDING_CLOSUER_SUCCESS, payload: response?.data?.data || [] });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DASHBOARD_EWAYBILL_PENDING_CLOSUER_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DASHBOARD_EWAYBILL_PENDING_CLOSUER_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const closureEwayDashboard = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DASHBOARD_EWAYBILL_PENDING_CLOSUER_REQUEST });
      const { auth } = getState();
      return axios.post(`/dashboard/closureEwayBill`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DASHBOARD_EWAYBILL_PENDING_CLOSUER_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DASHBOARD_EWAYBILL_PENDING_CLOSUER_FAILURE, error: error.message });
      throw error;
    }
  };
};